var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_vm._m(0),_c('div',{staticClass:"loading__desc mt-10"},[_vm._v(_vm._s(_vm.$t('login_loading')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-box"},[_c('div',{attrs:{"id":"largeBox"}}),_c('div',{attrs:{"id":"smallBox"}})])
}]

export { render, staticRenderFns }